import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Button, makeStyles, TextField, withStyles, Grid, MenuItem} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import {useTranslation} from 'react-i18next';
import {getUserPreference} from '../../../utilities/common';
import {showAlertSnackbar} from '../../../reducers/uiSlice';
import { useToken } from "../../../utilities/hooks";
import {getZipcodePatterns, updateRoutePattern, getWarehousePatterns} from "../../../actions/mmActions";
import UniDialog from '../../Common/UniDialog';

const InputTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
    },
}))(TextField);

const useStyles = makeStyles((theme) => ({
    selectWidth: {
        width: 200
    }
}));
const FixedTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 50,
        marginLeft: 20,
    },
}))(TextField);

function ReplanningRoute(props) {
    const dispatch = useDispatch();
    const { t } = useTranslation('updateToolbox');

    const routeFilterOptions = [
        { value: -1, label: t('all') },
        { value: 1, label: t('including') },
        { value: 0, label: t('excluding') },
    ];

    const batchTypeList = [
        { value: 'referer', label: t('batch_no') },
        { value: 'sub_batch', label: t('sub_batch') },
    ];

    const classes = useStyles();
    const userPref = getUserPreference();
    const [subBatch, setSubBatch] = useState('');
    const [routeNo, setRouteNo] = useState('');
    const [loading, setLoading] = useState(false);
    const [updated, setUpdated] = useState(0);
    const [disabled, setDisabled] = useState(true);
    const [pattern, setPattern] = useState(null);
    const [zipPatternList, setZipPatternList] = useState([]);
    const zipcodeLengthList = [3, 6]
    const [zipcodeLength, setZipcodeLength] = useState(zipcodeLengthList[0])
    const [routeNoFilter, setRouteNoFilter] = useState(-1);
    const tokenContents = useToken();
    const userUS = tokenContents.userUS;
    const [batchType, setBatchType] = useState('')
    const [batchNo, setBatchNo] = useState('')
    const [warehousePattern, setWarehousePattern] = useState('')
    const [alertOpen, setAlertOpen] = useState(false);

    const handleRouteNumberChange = (event) => {
        setRouteNoFilter(parseInt(event.target.value));
    };

    const handleRouteNo = (event) => {
        setRouteNo(event.target.value);
    };

    const handleBatchNo = (event) => {
        setBatchNo(event.target.value);
    };

    function handleSubmit() {
        setLoading(true);
        setAlertOpen(false);
        dispatch(updateRoutePattern(batchType, batchNo, userPref.userCity, pattern, routeNo, zipcodeLength, routeNoFilter))
            .then((res) => {
                setUpdated(res.updated);
                dispatch(showAlertSnackbar({ message: t('update_zipcode_pattern_success_message'), type: 'success' }))
                setLoading(false);
            })
            .catch((error) => {
                dispatch(showAlertSnackbar({ message: error.message, type: 'error' }))
                setLoading(false);
            })
    }

    useEffect(() => {
        dispatch(getWarehousePatterns(userPref.userCity)).then((res) => {
            setWarehousePattern(res);
        })
            .catch(() => {
                setLoading(false);
            })
    }, []);

    useEffect(() => {
        if (props.boxUpdate) {
            setBatchNo('');
        }
    }, [props.boxUpdate])

    useEffect(() => {
        if (batchNo && pattern != null && zipcodeLength) {
            setDisabled(false);

        } else {
            setDisabled(true);
        }
    }, [batchNo, pattern, zipcodeLength])

    useEffect(() => {
        dispatch(getZipcodePatterns(userPref.userCity)).then((res) => {
            setZipPatternList(res);
        })
            .catch(() => {
                setLoading(false);
            })
    }, []);

    return (
        <Grid container spacing={2}>
            <Grid item xs={3}>
                <TextField
                    fullWidth
                    select
                    label={t('batch_number_type')}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    value={batchType}
                    onChange={(e) => {
                        setBatchType(e.target.value);
                    }}
                    id="replanningroute_batchtype_fixtextfield"
                >
                    {batchTypeList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={3}>
                <InputTextField
                    fullWidth
                    variant="outlined"
                    placeholder={t('input_batch')}
                    onChange={handleBatchNo}
                    id="replanningroute_inputbatch_inputtextfield"
                    value={batchNo}
                />
            </Grid>
            <Grid item xs={3}>
                {zipPatternList && (
                    <TextField
                        fullWidth
                        select
                        label={t('zipcode_pattern')}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={pattern}
                        onChange={(e) => {
                            setPattern(e.target.value);
                        }}
                        id="replanningroute_pattern_textfield"
                    >
                        {zipPatternList.length > 0 &&
                            zipPatternList.map((zipPattern) => (
                                <MenuItem key={zipPattern.pattern_id} value={zipPattern.pattern_id}>
                                    {zipPattern.pattern_id}
                                </MenuItem>
                            ))}
                    </TextField>
                )}
            </Grid>
            <Grid item xs={3}>
                <p
                    id="replanningroute_warehousepattern_paragraph"
                    style={{ marginTop: '0', marginBottom: '0' }}
                >{t('default_warehouse_pattern')}{warehousePattern.current_pattern ?? 0}</p>
            </Grid>
            {
                (!userUS) &&
                <Grid item xs={3}>
                    <TextField
                        fullWidth
                        select
                        label={t('zipcode_length')}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={zipcodeLength}
                        onChange={(e) => {
                            setZipcodeLength(e.target.value);
                        }}
                        id="replanningroute_zipcodelength_fixtextfield"
                    >
                        {zipcodeLengthList.length > 0 &&
                            zipcodeLengthList.map((zipcodeLength) => (
                                <option key={zipcodeLength} value={zipcodeLength}>
                                    {'Length:' + zipcodeLength}
                                </option>
                            ))}
                    </TextField>
                </Grid>
            }
            <Grid item xs={3}>
                <TextField
                    select
                    fullWidth
                    label={t('re_plan_route')}
                    value={routeNoFilter}
                    onChange={handleRouteNumberChange}
                    variant="outlined"
                    id="replanningroute_replanroute_textfield"
                >
                    {routeFilterOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={6}>
                <InputTextField
                    variant="outlined"
                    fullWidth
                    placeholder={t('route_no_holder')}
                    onChange={handleRouteNo}
                    id="replanningroute_routeno_inputtextfield"
                    value={routeNo}
                />
            </Grid>
            <Grid item xs={12} style={{ marginBottom: '10px', textAlign: 'right' }}>
                <Button
                    color="primary"
                    variant="contained"
                    component="span"
                    disabled={disabled}
                    onClick={() => setAlertOpen(true)}
                    id="replanningroute_submid_button"
                >
                    {t('confirm_lot_update')}
                </Button>
                {loading && (
                    <div className={classes.buttonStyle}>
                        <CircularProgress color="secondary" />
                    </div>
                )}
            </Grid>
            <UniDialog
                open={alertOpen}
                autoClose={false}
                onClose={() => {
                    setAlertOpen(false);
                }}
                onFinish={() => {
                    handleSubmit();
                }}
                title={t('confirm_replanning')}
                cancelButtonText={t('common:close')}
                finishButtonText={t('common:ok')}
                maxwidth='sm'
                fullWidth
            >
                <div>{t('replanning_confirmed')}</div>
            </UniDialog>
        </Grid>
    );
};
      
export default ReplanningRoute;